"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_common_util_frontend_1 = require("@synisys/idm-common-util-frontend");
var idm_application_properties_service_client_js_1 = require("@synisys/idm-application-properties-service-client-js");
var model_1 = require("../model");
var operators_1 = require("rxjs/operators");
var idm_authentication_client_js_1 = require("@synisys/idm-authentication-client-js");
/**
 * Http implementation of PageNavigationService
 * @author ani.khachatryan
 */
var HttpPageNavigationService = /** @class */ (function () {
    function HttpPageNavigationService(applicationPropertiesService, httpClientWrapper) {
        this.httpClientWrapper = httpClientWrapper;
        this.serviceUrl = applicationPropertiesService
            .getProperty(HttpPageNavigationService_1.PAGE_SERVICE_KEY)
            .catch(this.handleError);
    }
    HttpPageNavigationService_1 = HttpPageNavigationService;
    HttpPageNavigationService.prototype.getNavigation = function () {
        var _this = this;
        return this.serviceUrl.then(function (url) {
            var urlOfRequest = HttpPageNavigationService_1.GET_NAVIGATION_PATH.replaceTemplate({
                serviceUri: url,
            });
            return _this.httpClientWrapper.get(urlOfRequest)
                .pipe(operators_1.map(function (response) {
                return response.map(function (navigationItem) { return model_1.NavigationItem.fromJson(navigationItem); });
            })).toPromise();
        });
    };
    HttpPageNavigationService.prototype.getPersonalNavigation = function () {
        var _this = this;
        return this.serviceUrl.then(function (url) {
            var urlOfRequest = HttpPageNavigationService_1.GET_PERSONAL_NAVIGATION_PATH.replaceTemplate({
                serviceUri: url,
            });
            return _this.httpClientWrapper.get(urlOfRequest)
                .pipe(operators_1.map(function (response) {
                return response.map(function (navigationItem) { return model_1.NavigationItem.fromJson(navigationItem); });
            })).toPromise();
        });
    };
    HttpPageNavigationService.prototype.handleError = function (error) {
        var errMsg = (error.message) ? error.message :
            error.status ? error.status + " - " + error.statusText : 'Server error';
        console.error(errMsg);
        return Promise.reject(errMsg);
    };
    HttpPageNavigationService.PAGE_SERVICE_KEY = "page-service-url";
    HttpPageNavigationService.GET_NAVIGATION_PATH = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_1 || (templateObject_1 = __makeTemplateObject(["", "/pages/public/navigation"], ["", "/pages/public/navigation"])), "serviceUri");
    HttpPageNavigationService.GET_PERSONAL_NAVIGATION_PATH = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_2 || (templateObject_2 = __makeTemplateObject(["", "/pages/my/navigation"], ["", "/pages/my/navigation"])), "serviceUri");
    HttpPageNavigationService = HttpPageNavigationService_1 = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [idm_application_properties_service_client_js_1.ApplicationPropertiesService,
            idm_authentication_client_js_1.HttpClientWrapper])
    ], HttpPageNavigationService);
    return HttpPageNavigationService;
    var HttpPageNavigationService_1;
}());
exports.HttpPageNavigationService = HttpPageNavigationService;
var templateObject_1, templateObject_2;
//# sourceMappingURL=http-page-navigation.service.js.map